import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import WelcomePanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const store = getStore();

const createWelcomeScreen = () => {
  const domId = 'welcomePanel';
  if (isSupportedBrowser()) {
    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <WelcomePanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createWelcomeScreen = createWelcomeScreen;
